
export const setID = id => dispatch => {
    dispatch({
      type: 'SET_ID',
      payload: id,
    });
  };